import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#111111] text-[#FAFAF7] py-24 px-4 sm:px-6" data-id="element-201">
      <div className="max-w-3xl mx-auto" data-id="element-202">
        {/* The Pain */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-20" data-id="element-203">
          <h2 className="text-3xl sm:text-4xl font-bold mb-8 text-center" data-id="element-204">
            Si tienes 25+ y vives con prisa… <br data-id="element-205" />
            <span className="text-[#E8652D]" data-id="element-206">esto te va a sonar</span>
          </h2>

          <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-207">
            No es que no sepas "qué es saludable". Es que cuando la vida
            aprieta, decidir qué comer se vuelve una carga.
          </p>

          <div className="grid sm:grid-cols-3 gap-6 my-10" data-id="element-208">
            <div className="bg-white/5 p-6 rounded-xl border border-white/10 text-center" data-id="element-209">
              <div className="text-3xl mb-3" data-id="element-210">🍔</div>
              <p className="font-semibold text-white" data-id="element-211">Comes lo primero</p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-white/10 text-center" data-id="element-212">
              <div className="text-3xl mb-3" data-id="element-213">💸</div>
              <p className="font-semibold text-white" data-id="element-214">Gastas más</p>
            </div>
            <div className="bg-white/5 p-6 rounded-xl border border-white/10 text-center" data-id="element-215">
              <div className="text-3xl mb-3" data-id="element-216">😫</div>
              <p className="font-semibold text-white" data-id="element-217">Te sientes pesado</p>
            </div>
          </div>

          <p className="text-xl text-gray-300 text-center italic" data-id="element-218">
            La frustración no viene por una comida. Viene por la sensación de:{' '}
            <br data-id="element-219" />
            <span className="text-white font-bold" data-id="element-220">
              "otra vez estoy fuera de control."
            </span>
          </p>
        </motion.div>

        {/* Why Counting Fails */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#1A1A1A] p-8 sm:p-10 rounded-2xl border border-white/5 mb-16" data-id="element-221">
          <h3 className="text-2xl font-bold mb-6 flex items-center gap-3" data-id="element-222">
            <XCircleIcon className="text-red-500 h-8 w-8" data-id="element-223" />
            Por qué contar calorías no te sirve
          </h3>
          <p className="text-gray-400 mb-6 text-lg" data-id="element-224">
            Contar funciona… hasta que te cansas. Porque el problema no es
            matemático. Es emocional y logístico:
          </p>
          <ul className="space-y-4 text-lg text-gray-300" data-id="element-225">
            <li className="flex items-center gap-3" data-id="element-226">
              <span className="h-1.5 w-1.5 rounded-full bg-red-500" data-id="element-227"></span>
              Llegas tarde
            </li>
            <li className="flex items-center gap-3" data-id="element-228">
              <span className="h-1.5 w-1.5 rounded-full bg-red-500" data-id="element-229"></span>
              Tienes hambre
            </li>
            <li className="flex items-center gap-3" data-id="element-230">
              <span className="h-1.5 w-1.5 rounded-full bg-red-500" data-id="element-231"></span>
              No quieres pensar
            </li>
            <li className="flex items-center gap-3" data-id="element-232">
              <span className="h-1.5 w-1.5 rounded-full bg-red-500" data-id="element-233"></span>
              No quieres medir
            </li>
          </ul>
        </motion.div>

        {/* The Solution */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-234">
          <h3 className="text-2xl sm:text-3xl font-bold mb-6" data-id="element-235">
            Lo que sí funciona para perder grasa sin obsesión
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-236">
            No necesitas "motivación". Necesitas un sistema que aguante tu
            semana real.
          </p>

          <div className="inline-block bg-[#E8652D] text-white p-1 rounded-2xl" data-id="element-237">
            <div className="bg-[#111111] rounded-xl p-8 border border-[#E8652D]/50" data-id="element-238">
              <p className="text-lg text-gray-400 mb-2" data-id="element-239">
                Por eso creé Meal Prep Turbo:
              </p>
              <p className="text-2xl sm:text-3xl font-bold text-white" data-id="element-240">
                Un método simple que te da{' '}
                <span className="text-[#E8652D]" data-id="element-241">estructura sin cárcel.</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}